<script>
export default {
  computed: {
      csrf_token: () => {
        return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    }
}
</script>
